













































































































































import { Component, Vue } from 'vue-property-decorator'
import { pick } from 'lodash'
import { format } from 'date-fns'
import { uuid } from 'uuidv4'

import eventModule from '@/store/event'
import authModule from '@/store/auth'
import userModule from '@/store/user'
import UserAvatar from '@/components/user/UserAvatar.vue'
import PasswordReset from '@/components/user/profile/PasswordReset.vue'
import { User } from '@/types/User'
import { TextFieldRules, Gender, GenderText } from '@/utils/enums'
import AWSManager from '@/utils/aws-manager'

@Component({
  name: 'UserEditor',
  components: {
    UserAvatar,
    PasswordReset
  }
})
class UserEditor extends Vue {
  private birthDateMenu = false
  private showDeletePrompt = false
  private rules = TextFieldRules

  private userForm: Partial<User> = {
    firstName: '',
    email: '',
    gender: '',
    birthDate: new Date()
  }
  private passwordForm = {
    oldPassword: '',
    newPassword: '',
    rePassword: ''
  }

  private get gender() {
    return Object.entries(Gender).map(entry => [GenderText[entry[0]], entry[1]])
  }

  private get formattedBirthDate(): string {
    if (!this.userForm.birthDate) return ''
    return format(new Date(this.userForm.birthDate), 'dd.MM.yyyy')
  }

  private promptForProfileDeletion() {
    this.showDeletePrompt = true
  }

  private async onDeleteConfirmed() {
    this.showDeletePrompt = false
    const success = await userModule.delete()

    if (success) {
      this.$router.push({ name: 'Login' })
    }
  }

  private onDeleteCancelled() {
    this.showDeletePrompt = false
  }

  private created(): void {
    this.userForm = pick(authModule.user, [
      'firstName',
      'email',
      'gender',
      'birthDate'
    ])
  }

  private updateProfile() {
    userModule.update(this.userForm)
    document.dispatchEvent(new Event('close-profile'))
  }

  private updatePassword() {
    userModule.updatePassword(
      pick(this.passwordForm, ['oldPassword', 'newPassword'])
    )
    document.dispatchEvent(new Event('close-profile'))
  }

  private toggleFileInput(): void {
    const fileInput = this.$refs.uploader as HTMLElement
    fileInput.click()
  }

  private async onFileChanged(e: Event): Promise<void> {
    const file = (e.target! as any).files[0]
    if (file !== null) {
      eventModule.newInfo(`Bild wird im Hintergrund hochgeladen`)
      const fileName = `${uuid()}.jpg`
      await AWSManager.uploadFile(
        `profiles/${authModule.user!.id}/picture/${fileName}`,
        file
      )

      await userModule.update({ picture: fileName })
    }
  }
}
export default UserEditor
